<template>
  <div>
    <e-modal modal-id="change-password">
      <div slot="title">Change password for {{ listUser.username }}</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12">
            <input type="password" placeholder="Password" v-model="password['pass']" class="form-control" @keydown.enter="updatePassword">
          </div>
          <div class="col-lg-12 m-t-xs m-b-xs">
            <input type="password" placeholder="Retype Password" v-model="password['retype']" class="form-control" @keydown.enter="updatePassword">
          </div>
          <div class="col-lg-12">
            <button class="btn-primary btn btn-xs" @click="updatePassword">Save</button>
          </div>
        </div>
      </div>
    </e-modal>
    <div v-if="listUser">
      <div class="row m-b-lg m-t-lg wrapper">
        <div class="col-md-12">
          <button class="btn btn-primary btn-sm pull-right" data-toggle="modal" data-target="#change-password">Change Password</button>
          <h3>{{ listUser.name }}</h3>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Name</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="listUser.name"
                      @input="updateProperty($event, 'name')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Username</td>
                  <td>
                    {{ listUser.username }}
                  </td>
                </tr>
                <tr>
                  <td>Email</td>
                  <td>
                    <e-txt
                      type="editable"
                      :text="listUser.email"
                      @input="updateProperty($event, 'email')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Admin</td>
                  <td>
                    <e-txt
                      type="select"
                      :text="listUser.admin"
                      :selectedValue="listUser.admin ? 'true' : 'false'"
                      :options="[{val: 'false', label: 'No'}, {val: 'true', label: 'Yes'}]"
                      selectLabel="label"
                      selectValue="val"
                      @input="updateProperty($event === 'true' ? 1 : 0, 'admin')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Roles</td>
                  <td>
                    <v-select v-if="user.admin" :options="userRoles" multiple v-model="roles" @input="updateProperty($event, 'roles')">
                    </v-select>
                    <span v-else><strong>{{ listUser.roles.join(', ') }}</strong></span>
                  </td>
                </tr>
                <tr>
                  <td>Active</td>
                  <td>
                    <e-txt
                      type="select"
                      :text="listUser.active"
                      :selectedValue="listUser.active ? 'true' : 'false'"
                      :options="[{val: 'false', label: 'No'}, {val: 'true', label: 'Yes'}]"
                      selectLabel="label"
                      selectValue="val"
                      @input="updateProperty($event === 'true' ? 1 : 0, 'active')"
                      close-on-save="true"
                    ></e-txt>
                  </td>
                </tr>
                <tr>
                  <td>Departments</td>
                  <td>
                    <v-select v-if="user.admin" :options="departments" multiple v-model="listUser.departments" index="index" @input="updateProperty($event, 'departments')">
                    </v-select>
                    <span v-else><strong>{{ listUser.roles.join(', ') }}</strong></span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            <div class="col-md-4">
              <table class="table small m-b-xs">
                <tbody>
                <tr>
                  <td>Clients</td>
                  <td>
                    <v-select v-if="user.admin && !listUser.admin && f.clients" multiple :options="f.clients" label="name" index="id" v-model="clients" @input="updateProperty($event, 'clients')">
                    </v-select>
                    <span v-else-if="!listUser.admin"><strong>{{ listUser.clients.map(c => c.name).join(', ') }}</strong></span>
                  </td>
                </tr>
                <tr>
                  <td>Groups</td>
                  <td>
                    <v-select
                      v-if="user.admin && !listUser.admin && f.groups" multiple
                      :options="f.groups.filter(g => listUser.clients.map(c => c.id).includes(g.client.id))"
                      v-model="listUser.groups"
                      label="fullName"
                      @input="updateProperty($event.map(g => g.id), 'groups')"
                    >
                    </v-select>
                    <span v-else-if="!listUser.admin"><strong>{{ listUser.clients.map(c => c.name).join(', ') }}</strong></span>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EditText from '../../../Helpers/Form/EditText'
import axios from 'axios'
import { USER_LIST_SET } from '../../../../store/mutation-types'
import Form from '../../../Helpers/Modal/Form'

export default {
  data () {
    return {
      password: {},
      listUser: {},
      departments: []
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters',
      user: 'getUser',
      userRoles: 'getUserRoles'
    }),
    clients: { get ({ listUser }) { return listUser.clients ? listUser.clients.map(c => c.id) : [] }, set () {} },
    roles: { get ({ listUser }) { return listUser.roles || [] }, set () {} }
  },
  components: {
    eTxt: EditText,
    eModal: Form
  },
  mounted () {
    this.getUser()
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
    this.loadDepartments()
    this.loaded = true
    document.title = `Admin Users: ${this.listUser.name || ''} :: PBN360 by Aphex Media`
  },
  methods: {
    async getUser () {
      let r = await axios.get(`/users/${this.$route.params.id}`)
      this.listUser = r.data
    },
    async loadDepartments () {
      try {
        this.departments = (await axios.get(`/v2/data-structures/departments`)).data.values
      } catch (e) {}
    },
    updateProperty (val, prop) {
      let data = {}
      data[prop] = val

      axios.patch(`/user/${this.listUser.id}`, data)
        .then(r => {
          const listUser = r.data.data
          this.$toastr.success(`${prop} updated successfully`, 'Good')
          this.$store.commit(USER_LIST_SET, this.listUsers.map(u => u.id === listUser.id ? listUser : u))
          this.$forceUpdate()
        })
        .catch(e => {
          this.$toastr.error(e, 'Unable to update')
        })

      return true
    },
    updatePassword () {
      if (this.password.pass.length < 6) {
        this.$toastr.error('Please put at least some effort in it and make it at least 6 chars long. Ok? Thanks *sigh*', 'Password too short')
        return
      }
      if (this.password.pass !== this.password.retype) {
        this.$toastr.error('Passwords don\'t match', 'No can\'t do')
        return
      }

      axios.patch(`/user/${this.listUser.id}/password`, {
        password: this.password.pass,
        retype: this.password.retype
      })
        .then(r => {
          this.$toastr.success('Password changed successfully')
          $('#change-password').modal('hide')
          this.password = {}
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/User/Header.vue